import RowSelectShortcuts from './RowSelectShortcuts'
import ColumnSelectShortcuts from './ColumnSelectShortcuts'
import CellSelectShortcuts from './CellSelectShortcuts'
import MultiCellSelectShortcuts from './MultiCellSelectShortcuts'
import MultiRowSelectShortcuts from './MultiRowSelectShortcuts'
import MultiColSelectShortcuts from './MultiColSelectShortcuts'
import { selectionTypes } from '../helpers'

{
  ROW
  COL
  CELL
  MULTI_CELL
  MULTI_ROW
  MULTI_COL
} = selectionTypes

export default SpreadSheetShortcuts = ({ selectionType }) ->

  switch selectionType
    when ROW        then <RowSelectShortcuts />
    when COL        then <ColumnSelectShortcuts />
    when CELL       then <CellSelectShortcuts />
    when MULTI_CELL then <MultiCellSelectShortcuts />
    when MULTI_ROW  then <MultiRowSelectShortcuts />
    when MULTI_COL  then <MultiColSelectShortcuts />
    else <div />




